import React, {Component} from 'react';
import {connect} from 'react-redux';
import ManageSolicitorAccount from "../components/manageSolicitorAccount";
import {
	changeFormData, changeManageSolAccountSettings, requestGetAcceptedToba, requestGetSolicitorDetails,
	requestUpdateSolicitorDetails, requestUpdateSolicitorPassword, toggleError
} from "../actions/manageSolicitorAccount";
import { push } from 'connected-react-router'
import {isPhone} from "../helpers/functions";

class ManageSolicitorAccountHOC extends Component {

	componentWillMount() {
		this.props.getSolicitorDetails(this.props.user.loggedInUser.id);
	}

	handlePasswordChange = (evt) => {
		evt.preventDefault();
		let formData = this.props.manageSolicitorAccount.formData;
		if (this.props.manageSolicitorAccount.formData.newPassword !== this.props.manageSolicitorAccount.formData.retypedNewPassword) {
			this.props.changeErrorState('notSamePassword', 'Unable to update Password: Passwords do not match.')
		}
		else if (this.props.manageSolicitorAccount.formData.newPassword === this.props.manageSolicitorAccount.formData.retypedNewPassword && (this.props.manageSolicitorAccount.formData.newPassword !== "")) {
			if (this.props.manageSolicitorAccount.formData.newPassword.length < 8) {
				this.props.changeErrorState('shortPassword', 'Unable to update Password: Password isn\'t strong enough. Password must be: 8 characters and contain at least one of each... Capitol, lower case, a number and a symbol.')
			}
			else {
				let hasUpperCase = /[A-Z]/.test(this.props.manageSolicitorAccount.formData.newPassword);
				let hasLowerCase = /[a-z]/.test(this.props.manageSolicitorAccount.formData.newPassword);
				let hasNumbers = /[0-9]/.test(this.props.manageSolicitorAccount.formData.newPassword);
				let hasNonalphas = /\W/.test(this.props.manageSolicitorAccount.formData.newPassword);
				if (hasUpperCase + hasLowerCase + hasNumbers + hasNonalphas < 3) {
					this.props.changeErrorState('notComplexPassword', 'Unable to update Password: Password isn\'t strong enough. Password must be: 8 characters and contain at least one of each... Capitol, lower case, a number and a symbol.')
				}
				else {
					let sendBody = {
						oldPassword: this.props.manageSolicitorAccount.formData.password,
						userId: this.props.manageSolicitorAccount.solicitorData.userId,
						newPassword: this.props.manageSolicitorAccount.formData.newPassword,
						reNewPassword: this.props.manageSolicitorAccount.formData.retypedNewPassword,
					};
					this.props.requestUpdateSolicitorPassword(sendBody)
				}
			}
		}
	};

	HandleSubmit = (evt) => {
		evt.preventDefault();
		let formData = this.props.manageSolicitorAccount.formData;
		let valid = true;
		if ( !isPhone(formData.telephoneNumber1) && (formData.telephoneNumber1 !== '')) {
			valid = false;
			this.props.changeManageSolAccountSettings('notValidTel1', 'Telephone number is not valid.')
		}
		if (!isPhone(formData.telephoneNumber2) && (formData.telephoneNumber2 !== '')) {
			valid = false;
			this.props.changeManageSolAccountSettings('notValidTel2', 'Telephone number is not valid.')

		}
		if (this.props.manageSolicitorAccount.formData.newPassword !== this.props.manageSolicitorAccount.formData.retypedNewPassword) {
			this.props.changeErrorState('notSamePassword', 'Unable to update Password: Passwords do not match.')
			valid = false;
		}
		else if (this.props.manageSolicitorAccount.formData.newPassword === this.props.manageSolicitorAccount.formData.retypedNewPassword && (this.props.manageSolicitorAccount.formData.newPassword !== "")) {
			if (this.props.manageSolicitorAccount.formData.newPassword.length < 8) {
				this.props.changeErrorState('shortPassword', 'Unable to update Password: Password isn\'t strong enough. Password must be: 8 characters and contain at least one of each... Capitol, lower case, a number and a symbol.');
				valid = false;
			}
			else {
				let hasUpperCase = /[A-Z]/.test(this.props.manageSolicitorAccount.formData.newPassword);
				let hasLowerCase = /[a-z]/.test(this.props.manageSolicitorAccount.formData.newPassword);
				let hasNumbers = /[0-9]/.test(this.props.manageSolicitorAccount.formData.newPassword);
				let hasNonalphas = /\W/.test(this.props.manageSolicitorAccount.formData.newPassword);
				if (hasUpperCase + hasLowerCase + hasNumbers + hasNonalphas < 3) {
					this.props.changeErrorState('notComplexPassword', 'Unable to update Password: Password isn\'t strong enough. Password must be: 8 characters and contain at least one of each... Capitol, lower case, a number and a symbol.')
					valid = false;
				}
				else if (valid) {
					let sendBody = {
						userId: this.props.manageSolicitorAccount.solicitorData.userId,
						oldPassword: this.props.manageSolicitorAccount.formData.password,
						newPassword: this.props.manageSolicitorAccount.formData.newPassword,
						reNewPassword: this.props.manageSolicitorAccount.formData.retypedNewPassword,
						forename: this.props.manageSolicitorAccount.formData.forename,
						surname: this.props.manageSolicitorAccount.formData.surname,
						telephone1: this.props.manageSolicitorAccount.formData.telephoneNumber1,
						telephone1Description: this.props.manageSolicitorAccount.formData.telephoneNumber1Description,
						telephone2: this.props.manageSolicitorAccount.formData.telephoneNumber2,
						telephone2Description: this.props.manageSolicitorAccount.formData.telephoneNumber2Description
					};
					this.props.updateSolicitor(sendBody)
				}
			}
		}
		else if (valid) {
			let sendBody = {
				userId: this.props.manageSolicitorAccount.solicitorData.userId,
				forename: this.props.manageSolicitorAccount.formData.forename,
				surname: this.props.manageSolicitorAccount.formData.surname,
				telephone1: this.props.manageSolicitorAccount.formData.telephoneNumber1,
				telephone1Description: this.props.manageSolicitorAccount.formData.telephoneNumber1Description,
				telephone2: this.props.manageSolicitorAccount.formData.telephoneNumber2,
				telephone2Description: this.props.manageSolicitorAccount.formData.telephoneNumber2Description
			};
			this.props.updateSolicitor(sendBody)
		}
	};

	render() {
		let error = this.props.manageSolicitorAccount.error;
		let errorExists = ((error.shortPassword) || (error.notSamePassword) || (error.notComplexPassword))
		return (
      <ManageSolicitorAccount HandleSubmit={this.HandleSubmit}
                              tobaAccepted={this.props.user.loggedInUser.toba}
                              push={this.props.push}
                              handlePasswordChange={this.handlePasswordChange}
                              changeManageSolAccountSettings={this.props.changeManageSolAccountSettings}
                              ErrorMessage={this.props.manageSolicitorAccount.error.errorMessage}
                              ErrorExists={errorExists}
                              User={this.props.manageSolicitorAccount.solicitorData}
                              FormData={this.props.manageSolicitorAccount.formData}
                              Store={this.props.manageSolicitorAccount}
                              HandleInputChange={this.props.handleInputChange}/>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		manageSolicitorAccount: state.manageSolicitorAccount,
		user: state.user
	}
};

const mapDispatchToProps = (dispatch) => {
	return {
		handleInputChange: (field, data) => {
			dispatch(changeFormData(field, data))
		},
		getSolicitorDetails: (id) => {
			dispatch(requestGetSolicitorDetails(id))
		},
		updateSolicitor: (sendBody) => {
			dispatch(requestUpdateSolicitorDetails(sendBody))
		},
		changeErrorState: (errorType, message) => {
			dispatch(toggleError(errorType, message))
		},
		getAcceptedToba: (id) => {
			dispatch(requestGetAcceptedToba(id))
		},
		changeManageSolAccountSettings: (key, value) => {
			dispatch(changeManageSolAccountSettings(key, value))
		},
		requestUpdateSolicitorPassword: (sendBody) => {
			dispatch(requestUpdateSolicitorPassword(sendBody))
		},
		push: (url) => {
			dispatch(push(url))
		}
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageSolicitorAccountHOC);